export const initEvents = () => {
	if (!document.querySelector(".tribe-events-view")) return;

	initCategoryUIUpdateObserver(() => {
		updateFilterUI();
	});
};

function initCategoryUIUpdateObserver(callback) {
	const context = {
		calendarObserver: null,
		bodyObserver: null,
	};

	context.bodyObserver = new MutationObserver((mutationsList, observer) => {
		handleBodyMutation(mutationsList, observer, context, callback);
	});
	context.bodyObserver.observe(document.body, { childList: true, subtree: true });

	observeCalendar(context, callback);
}

function handleCalendarMutation(mutationsList, observer, callback) {
	if (typeof callback === "function") callback();
}

function observeCalendar(context, callback) {
	const calendarContainer = document.querySelector(".tribe-events-view");
	if (!calendarContainer) return;

	if (context.calendarObserver) context.calendarObserver.disconnect();

	context.calendarObserver = new MutationObserver((mutationsList, observer) => {
		handleCalendarMutation(mutationsList, observer, callback);
	});
	context.calendarObserver.observe(calendarContainer, { childList: true, subtree: true });
}

function handleBodyMutation(mutationsList, observer, context, callback) {
	for (const mutation of mutationsList) {
		for (const node of mutation.addedNodes) {
			if (node.nodeType === 1 && node.matches(".tribe-events-view")) {
				observeCalendar(context, callback);
			}
		}
	}
}

const updateFilterUI = () => {
	// wait for the select2 to be initialized
	waitForElement(
		".tribe-filter-bar-c-filter fieldset .select2-results__options li",
		() => {
			// handleFilterChange(el);
			const options = document.querySelectorAll(
				".tribe-filter-bar-c-filter fieldset .select2-results__options li",
			);
			options.forEach((el) => {
				// console.log("Adding click event for el: ", el);
				el.addEventListener("click", () => {
					handleFilterChange(el);
				});
			});
		},
		10,
	);
};

const handleFilterChange = (el) => {
	if (!document.querySelector(".select2-selection__choice__text")) return;

	const selected = document.querySelector(".select2-selection__choice__text");
	if (!selected.innerText) return;
	const selectedText = selected.innerText;

	setTimeout(() => {
		const matchedOption = getMatchedText(selectedText);
		if (!matchedOption) return;
		matchedOption.classList.add("selected-option");
	}, 300);
};

const getMatchedText = (text) => {
	const options = document.querySelectorAll(".tribe-filter-bar-c-filter fieldset .select2-results__options li");
	if (!options || options.length === 0) return null;
	let matchedOption = null;
	options.forEach((option) => {
		option.style.textTransform = "none";
		if (option.innerText === text) {
			matchedOption = option;
		}
		option.style.textTransform = "uppercase";
	});
	return matchedOption;
};

const waitForElement = (el, callback, attempts = 10) => {
	let element = null;
	if (typeof el === "string") {
		element = document.querySelector(el);
	} else {
		element = el;
	}
	// const element = document.querySelector(selector);
	if (element) {
		callback(element);
	} else if (attempts > 0) {
		setTimeout(() => {
			waitForElement(selector, callback, attempts - 1);
		}, 500);
	}
};
